import medalliaAppSwitcher from '@m/app-switcher';
import { AppSwitcherOptions } from '@m/app-switcher/src/state';

const appSwitcher = document.getElementById('m_app_switcher');
let appSwitcherController: any = null;
if (appSwitcher) {
    appSwitcher.classList.add('loading');
    const opts: AppSwitcherOptions = {
        iconSizePx: 32, // Size of the Icon
        locale: 'en', // localization, not important because you are in charge of the lang
        skipLogin: true, // Skip forcing a login for hardcoding
        themeOption: 'light', // can also be 'dark'
        headerText: appSwitcher.getAttribute('data-label-select') || '',
        staticLinks: [
            {
                name: appSwitcher.getAttribute('data-name') || '', // This must be i18n by Agile Research. Currently stored in account.IdentityProvider - AppSwitcherMenuLabel or default.
                url: appSwitcher.getAttribute('data-url') || '', // Where you want to go on the click,
                icon: 'MEC', // This is to make the right logo
            },
            {
                name: 'Agile Research', // This must be i18n by Agile Research
                url: window.location.origin,
                icon: 'AGILE_RESEARCH', // This is to make the right logo
                highlighted: true, // This will make a decorator around the list item when you are in the app
            },
        ],
    };

    (async () => {
        appSwitcherController = await medalliaAppSwitcher(opts);
        appSwitcher.classList.remove('loading');
    })();
}
document.onclick = (e) => {
    if (appSwitcherController && document.getElementById('app_switcher_nav_dom_node_m_app_switcher') != null) {
        if (!(e.target as any)?.matches('#app_switcher_nav_dom_node_m_app_switcher *, #m_app_switcher *')) {
            appSwitcherController.toggleMenu();
        }
    }
};
